import {IVanillaReaderUserProfileData} from "../VanillaReader/VanillaReaderModel";
import {Sha1, Random} from "@colibrio/colibrio-reader-framework/colibrio-core-encryption";
import getRandomHexString = Random.getRandomHexString;
import {VanillaReaderLocalStorageKeys} from "../VanillaReaderDataStore/VanillaReaderStoreModel";

/**
 *
 * # VanillaReaderAppUserProfile
 *
 * ## RESPONSIBILITIES
 *
 *
 * ## RELATED TYPES
 *
 * */
export class VanillaReaderAppUserProfile {

    // This function returns a IVanillaReaderUserProfileData from LocalStorage. If no user data has been stored previously,
    // the data is created object and stored.
    static async fetchOrCreateUserProfile(): Promise<IVanillaReaderUserProfileData> {
        let userProfileData: IVanillaReaderUserProfileData;
        let userProfileDataString = window.localStorage.getItem(VanillaReaderLocalStorageKeys.VanillaReaderUserProfileData);

        if (!userProfileDataString) {
            let uuid = getRandomHexString(12);
            let token = VanillaReaderAppUserProfile._createDigestFromString(uuid);
            userProfileData = {
                id: uuid,
                token,
            };
            window.localStorage.setItem(VanillaReaderLocalStorageKeys.VanillaReaderUserProfileData, JSON.stringify(userProfileData));
        } else {
            userProfileData = JSON.parse(userProfileDataString);
        }

        return userProfileData;
    }

    // This function creates a SHA256 hash from a string value. This is to demonstrate and emphasise that the user id
    // should always be obfuscated before used with the framework.
    static _createDigestFromString(stringValue: string): string {
        let sha = new Sha1();
        sha.append(stringValue);
        return sha.digestToHex();
    }

}
